<style scoped lang="scss">
.loading_area {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  &.page {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, .5);
    ._logo {
      width: 18%;
      height: 18%;
    }
  }
  &.area {
    // position: relative;
    top: 0;
    left: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0);
    ._logo {
      width: 10%;
      height: 10%;
    }
    h5 {
      font-size: 1rem;
    }
  }
}
</style>

<template>
  <div :class="['loading_area', mode]">
    <!-- <div class="animated flipInX infinite">
      <img class="_logo" :src="logo">
      <h5 class="text-muted mt-2">Loading</h5>
    </div> -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated flipInY"
      leave-active-class="animated flipOutY"
    >
      <div v-if="show">
        <img class="_logo" :src="logo">
        <h5 :class="[mode === 'page' ? 'text-light' : 'text-dark', 'mt-2']">loading</h5>
      </div>
    </transition>
  </div>
</template>

<script>
import logo from '@/assets/intrising-logo/logo.svg'

export default {
  props: {
    mode: {
      type: String,
      default: 'page'
    }
  },
  components: {

  },
  data () {
    return {
      timeoutHolder: null,
      show: true,
      /** logo */
      logo
    }
  },
  computed: {

  },
  methods: {
    repeater () {
      this.timeoutHolder = setTimeout(() => {
        this.show = !this.show
        this.repeater()
      }, 1000)
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.repeater()
    })
  },
  beforeDestroy () {
    clearTimeout(this.timeoutHolder)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Loading.vue